import { Component, OnInit, TemplateRef } from '@angular/core';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router, ActivatedRoute} from '@angular/router';
import { environment } from 'src/environments/environment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { OrderService } from '../../Services/order.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { AlertService } from 'src/app/core/services/alert.service';
import { Title } from '@angular/platform-browser';
import { OrderConsts } from '../../constants';

@Component({
    selector: 'app-orders-available-cart',
    templateUrl: './orders-available-cart.component.html',
    styleUrls: ['./orders-available-cart.component.scss'],
    standalone: false
})
export class OrdersAvailableCartComponent implements OnInit {
  removeProductCount = 0;
  loading1 = false;
  loading2 = false;
  loading3 = false;
  loading4 = false;
  nextPageForItemDiscontinue = 1;
  nextPageForItemsNotInRange = 1;
  nextPageForItemOutofStock = 1;
  nextPageForItemAvailable = 1;
  componentLoaded = false;
  orderItemDiscontinue = [];
  orderItemsNotInRange = [];
  orderItemOutofStock = [];
  orderItemAvailable = [];
  totalorderItemDiscontinuePages = 1;
  totalorderItemDiscontinueCount = 0;
  totalorderItemsNotInRangePages = 1;
  totalorderItemsNotInRangeCount = 0;
  totalorderItemOutofStockPages = 1;
  totalorderItemOutofStockCount = 0;
  totalorderItemAvailablePages = 1;
  totalorderItemAvailableCount = 0;
  noRecordForItemDiscontinue = true;
  noRecordForItemsNotInRange = true;
  noRecordForItemOutofStock = true;
  noRecordForItemAvailable = true;
  page_size = environment.cart_page_size
  imagePath = environment.s3_path + '/' + environment.product_image_folder + '/'
  allProductCounts: any;
  removeProduct = {};
  removeProductsIds = [];
  removeType = '';
  bsModalRef: BsModalRef;
  removeHeading = '';
  orderId: any;
  newOrderProductList = []
  constructor(private router: Router, private orderService: OrderService,
    private modalService: BsModalService,
    private titleService: Title,
    private alertService: AlertService,
    private statePersistService: StatePersistService,
    private statePersist: StatePersistService, private activatedRoute: ActivatedRoute) {
    const body = document.getElementsByTagName('body')[0];
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(res => {
      if (this.router.url == "/order/detail/:orderid") {
        body.classList.add('adjust-logo','remove-footer-accordion');
      }
      else {
        body.classList.remove('adjust-logo','remove-footer-accordion');
      }
    });
  }
  ngOnInit(): void { 
    this.titleService.setTitle(OrderConsts.COPY_ORDER_PAGE_TITLE);
    this.statePersistService.watchReorderStorage().subscribe(message => {
      this.orderId = this.activatedRoute.snapshot.paramMap.get('orderid')
      this.statePersist.setLocalStorage('product_data', {}, 'search')
      this.statePersist.removeLocalStorage('product_data')
      this.orderItemDiscontinue = [];
      this.orderItemsNotInRange = [];
      this.orderItemOutofStock = [];
      this.orderItemAvailable = [];
      this.loading1 = false;
      this.loading2 = false;
      this.loading3 = false;
      this.loading4 = false;
      this.nextPageForItemDiscontinue = 1;
      this.nextPageForItemsNotInRange = 1;
      this.nextPageForItemOutofStock = 1;
      this.nextPageForItemAvailable = 1;
      this.totalorderItemDiscontinuePages = 1;
      this.totalorderItemDiscontinueCount = 0;
      this.totalorderItemsNotInRangePages = 1;
      this.totalorderItemsNotInRangeCount = 0;
      this.totalorderItemOutofStockPages = 1;
      this.totalorderItemOutofStockCount = 0;
      this.totalorderItemAvailablePages = 1;
      this.totalorderItemAvailableCount = 0;
      this.noRecordForItemDiscontinue = true;
      this.noRecordForItemsNotInRange = true;
      this.noRecordForItemOutofStock = true;
      this.noRecordForItemAvailable = true;
      this.getCopyOrderData()
      this.statePersist.emitstoreListing('store list update')
      var storeCount = this.statePersist.getLocalStorage('selectedStoreAddress')
      if (storeCount['totalStoreCount'] > 1){
        this.alertService.info('Change the store from here')
      }
    })
    this.orderId = this.activatedRoute.snapshot.paramMap.get('orderid')
    this.statePersist.setLocalStorage('product_data', {}, 'search')
    this.statePersist.removeLocalStorage('product_data')
    this.getCopyOrderData()
    var storeCountNew = this.statePersist.getLocalStorage('selectedStoreAddress')
    if (storeCountNew['totalStoreCount'] > 1){
      this.alertService.info('Change the store from here')
    }
  }

  initialGetFororderItemDiscontinue(data){
    this.totalorderItemDiscontinueCount = data.product_count
    this.totalorderItemDiscontinuePages = data.total_pages
    if (this.totalorderItemDiscontinuePages < this.nextPageForItemDiscontinue + 1) {
      this.nextPageForItemDiscontinue = null;
    }
    else {
      this.nextPageForItemDiscontinue += 1;
    }
    if (this.totalorderItemDiscontinueCount == 0) {
      this.noRecordForItemDiscontinue = true;
      this.orderItemDiscontinue = [];
      this.nextPageForItemDiscontinue = 1;
      this.totalorderItemDiscontinueCount = 0;
      this.totalorderItemDiscontinuePages = 1
    }
    else {
      this.noRecordForItemDiscontinue = false;

    }
    for (let i = 0; i < data.items.length; i++) {
      this.orderItemDiscontinue.push(data.items[i]);
    }
  
  }

  initialGetForItemsNotInRange(data){
    this.totalorderItemsNotInRangeCount = data.product_count
    this.totalorderItemsNotInRangePages = data.total_pages
    if (this.totalorderItemsNotInRangePages < this.nextPageForItemsNotInRange + 1) {
      this.nextPageForItemsNotInRange = null;
    }
    else {
      this.nextPageForItemsNotInRange += 1;
    }
    if (this.totalorderItemsNotInRangeCount == 0) {
      this.noRecordForItemsNotInRange = true;
      this.orderItemsNotInRange = [];
      this.nextPageForItemsNotInRange = 1;
      this.totalorderItemsNotInRangeCount = 0;
      this.totalorderItemsNotInRangePages = 1
    }
    else {
      this.noRecordForItemsNotInRange = false;

    }
    for (let i = 0; i < data.items.length; i++) {
      this.orderItemsNotInRange.push(data.items[i]);
    }
  
  }

  initialGetFororderItemOutofStock(data){
    this.totalorderItemOutofStockCount = data.product_count
    this.totalorderItemOutofStockPages = data.total_pages
    if (this.totalorderItemOutofStockPages < this.nextPageForItemOutofStock + 1) {
      this.nextPageForItemOutofStock = null;
    }
    else {
      this.nextPageForItemOutofStock += 1;
    }
    if (this.totalorderItemOutofStockCount == 0) {
      this.noRecordForItemOutofStock = true;
      this.orderItemOutofStock  = [];
      this.nextPageForItemOutofStock  = 1;
      this.totalorderItemOutofStockCount = 0;
      this.totalorderItemOutofStockPages = 1
    }
    else {
      this.noRecordForItemOutofStock = false;

    }
    for (let i = 0; i < data.items.length; i++) {
      this.orderItemOutofStock.push(data.items[i]);
    }
  
  }

  initialGetForItemAvailable(data){
    this.totalorderItemAvailableCount = data.product_count - this.removeProductCount
    this.totalorderItemAvailablePages = data.total_pages
    if (this.totalorderItemAvailablePages < this.nextPageForItemAvailable + 1) {
      this.nextPageForItemAvailable = null;
    }
    else {
      this.nextPageForItemAvailable += 1;
    }
    if (this.totalorderItemAvailableCount == 0) {
      this.noRecordForItemAvailable = true;
      this.orderItemAvailable = [];
      this.nextPageForItemAvailable = 1;
      this.totalorderItemAvailableCount = 0;
      this.totalorderItemAvailablePages = 1
    }
    else {
      this.noRecordForItemAvailable = false;

    }
    for (let i = 0; i < data.items.length; i++) {
      this.orderItemAvailable.push(data.items[i]);
      this.newOrderProductList.push(data.items[i]);
    }
  
  }

  getCopyOrderData() {
    this.orderService.getCopyOrders( {"order_id": this.orderId,"page": 1, "page_size":this.page_size})
    .subscribe(
      data => {
        if (data.response) {
            const orderItemDiscontinue = data.response. order_item_discontinue;
            const orderItemsNotInRange = data.response. order_items_not_in_range;
            const orderItemOutofStock = data.response. order_item_out_of_stock;
            const orderItemAvailable = data.response. order_item_available;
            this.initialGetFororderItemDiscontinue(orderItemDiscontinue)
            this.initialGetForItemsNotInRange(orderItemsNotInRange)
            this.initialGetFororderItemOutofStock(orderItemOutofStock)
            this.initialGetForItemAvailable(orderItemAvailable)
              
        }
        this.loading1 = false;
        this.loading2 = false;
        this.loading3 = false;
        this.loading4 = false;
        this.componentLoaded = true;
        var storeCountObj = this.statePersist.getLocalStorage('selectedStoreAddress')
        if (storeCountObj['totalStoreCount'] > 1){
          this.alertService.info('Change the store from here')
        }
        
      }
    );
  }

  getItemDiscontinue(){
    this.orderService.getdiscontinueOrderItems( {"order_id": this.orderId,"page": this.nextPageForItemDiscontinue, "page_size":this.page_size})
    .subscribe(
      data => {
        if (data.response) {
            const orderItemDiscontinue = data.response;
            this.initialGetFororderItemDiscontinue(orderItemDiscontinue)
        }
        this.loading1 = false;
        this.componentLoaded = true;
      }
    );
  }

  getItemsNotInRange(){
    this.orderService.getnotMyRangeOrderItems( {"order_id": this.orderId,"page": this.nextPageForItemsNotInRange, "page_size":this.page_size})
    .subscribe(
      data => {
        if (data.response) {
            const orderItemnotMyRange = data.response;
            this.initialGetForItemsNotInRange(orderItemnotMyRange)
        }
        this.loading2 = false;
        this.componentLoaded = true;
      }
    );
  }

  getoutOfStockOrderItems(){
    this.orderService.getoutOfStockOrderItems( {"order_id": this.orderId,"page": this.nextPageForItemOutofStock, "page_size":this.page_size})
    .subscribe(
      data => {
        if (data.response) {
            const outOfStockOrderItems = data.response;
            this.initialGetFororderItemOutofStock(outOfStockOrderItems)
        }
        this.loading3 = false;
        this.componentLoaded = true;
      }
    );
  }

  getavailableOrderItems(){
    this.orderService.getavailableOrderItems( {"order_id": this.orderId,"page": this.nextPageForItemAvailable, "page_size":this.page_size})
    .subscribe(
      data => {
        if (data.response) {
            const availableOrderItems = data.response;
            this.initialGetForItemAvailable(availableOrderItems)
        }
        this.loading4 = false;
        this.componentLoaded = true;
      }
    );
  }

  
  onScrollDownForItemDiscontinue(){
    if ((this.nextPageForItemDiscontinue != 1 && this.nextPageForItemDiscontinue !== null) && !this.loading2) {
      this.loading1 = true;
      this.getItemDiscontinue()
    }
  
  }

  onScrollDownForItemsNotInRange (){
    if ((this.nextPageForItemsNotInRange != 1 && this.nextPageForItemsNotInRange !== null) && !this.loading2) {
      this.loading2 = true;
      this.getItemsNotInRange()
    }
  
  }

  onScrollDownFororderItemOutofStock(){
    if ((this.nextPageForItemOutofStock != 1 && this.nextPageForItemOutofStock !== null) && !this.loading3) {
      this.loading3 = true;
      this.getoutOfStockOrderItems()
    }
  
  }

  onScrollDownForavailableOrderItems (){
    if ((this.nextPageForItemAvailable != 1 && this.nextPageForItemAvailable !== null) && !this.loading4) {
      this.loading4 = true;
      this.getavailableOrderItems()
    }
  
  }

  orderItemsAddToCart(){
    var productsList;
    productsList = []
    for (let i = 0; i < this.orderItemAvailable.length; i++) {
      productsList.push({"product_id": this.orderItemAvailable[i]['product_id'],"qty": this.orderItemAvailable[i]['item_qty']})
    }
    this.orderService.orderItemsAddToCart( {"order_id": this.orderId, 'remove_ids':this.removeProductsIds, 'product_list':productsList})
    .subscribe(
      data => {
        if (data.response) {
          if(data.status == 1180){
            localStorage.setItem('closeStorInfoMessage', data.response.msg)
            document.getElementById("openclosedStoreInfo").click();
          }
          else if (data.status == 2212){
            this.alertService.error(data.response)
          }
          else{
            this.alertService.success(data.response.msg)
            this.router.navigate(['/mycart'])
          }
          
        }
        
      }
    );
  }

  removeonSpinnerPopup(template: TemplateRef<any>, selectedProduct) {
    this.removeProduct = selectedProduct
    this.removeHeading = 'Are you sure you want to remove product from cart?'
    this.bsModalRef = this.modalService.show(template,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }));
  }
  
  qytUpdate(product, qyt, template: any) {
    if (qyt == 0){
      for (let i = 0; i < this.orderItemAvailable.length; i++) {
        if (this.orderItemAvailable[i]['product_id'] == product.product_id) {
          this.orderItemAvailable[i]['item_qty'] = '0'
        }
      }
      
      this.removeonSpinnerPopup(template, product)
    }
    else{
     for (let i = 0; i < this.orderItemAvailable.length; i++) {
        if (this.orderItemAvailable[i]['product_id'] == product.product_id) {
          this.orderItemAvailable[i]['item_qty'] = qyt
        }
      }
    }
    
  }


  removePopup(template: TemplateRef<any>, type, selectedProduct) {
    if(type != 'All'){
      
      this.removeProduct = selectedProduct
      this.removeType = ''
      this.removeHeading = 'Are you sure you want to remove product from Available Products?'
    }
    else{
      this.removeProduct= {}
      this.removeType = type
      this.removeHeading = 'Are you sure you want to remove all products from Available Products?'
    }
    this.bsModalRef = this.modalService.show(template,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }));
  }

  toInteger(value) {
    return parseInt(value)
  }

  cancleRequest(product){
    this.bsModalRef.hide()
    for (let i = 0; i < this.orderItemAvailable.length; i++) {
      if (this.orderItemAvailable[i]['product_id'] == product.product_id) {
        this.orderItemAvailable[i]['item_qty'] = '1'
      }
    }
  }

  removeItem(product){
    this.newOrderProductList = this.newOrderProductList.filter(item => item.product_id !== product.product_id);
    this.orderItemAvailable = this.orderItemAvailable.filter(item => item.product_id !== product.product_id);
    this.bsModalRef.hide();
    this.totalorderItemAvailableCount = this.totalorderItemAvailableCount - 1
    this.removeProductCount += 1 
    this.removeProductsIds.push(product.product_id)
  }

  clearCart(){
    this.bsModalRef.hide();
    this.removeProductsIds = [];
    for (let i = 0; i < this.orderItemAvailable.length; i++) {
      this.removeProductsIds.push(this.orderItemAvailable[i]['product_id'])
    }
    this.removeProductCount = this.totalorderItemAvailableCount;
    this.noRecordForItemAvailable = true;
    this.orderItemAvailable = [];
    this.newOrderProductList = [];
    this.nextPageForItemAvailable = 1;
    this.totalorderItemAvailableCount = 0;
    this.totalorderItemAvailablePages = 1
  }

  isFirstOpen = false;
  isFirstOpen1 = true;
}
